import { useEffect } from 'react';

import { Box, Dialog, DialogHeader, DialogBody, DialogDescription } from '@gusto/workbench';

import AccountAlreadyExistsCard from './accountAlreadyExistsCard';
import AccountAlreadyExistsAccordion from './accountAlreadyExistsAccordion';

interface AccountAlreadyExistsDialogProps {
  isOpen: boolean;
  setIsOpen(open: boolean): void;
  updateEmailField(): void;
}

const AccountAlreadyExistsDialog = ({
  isOpen,
  setIsOpen,
  updateEmailField,
}: AccountAlreadyExistsDialogProps): JSX.Element => {
  useEffect(() => {
    if (isOpen) {
      GustoAnalytics.track({
        eventCategory: 'Dialog',
        eventName: 'Open',
        data: {
          identifier: 'account_already_exists_dialog',
        },
      });
    }
  }, [isOpen]);

  const closeAccordion = (location?: string) => {
    const identifier = location
      ? `account_already_exists_dialog: ${location}`
      : 'account_already_exists_dialog';

    GustoAnalytics.track({
      eventCategory: 'Dialog',
      eventName: 'Close',
      data: {
        identifier,
      },
    });
    setIsOpen(false);
    if (location === 'chat') {
      updateEmailField();
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => closeAccordion()}
      aria-label="It looks like you already have a Gusto account. Would you like to sign in?"
      className="account-already-exists"
    >
      <DialogHeader
        className="account-already-exists__dialog-header"
        heading="It looks like you already have a Gusto account"
      />
      <DialogBody>
        <DialogDescription>
          <Box marginBottom={8}>
            <AccountAlreadyExistsCard />
          </Box>
          <Box>
            <AccountAlreadyExistsAccordion />
          </Box>
        </DialogDescription>
      </DialogBody>
    </Dialog>
  );
};

export default AccountAlreadyExistsDialog;
